module.exports = __webpack_public_path__ + "img/3REDBERRIES.dbd09f37.png";